import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import firebaseInit from "../../firebase";
import Cookies from "js-cookie";

export const logActivity = async ({
  category,
  event,
  level = `info-${process.env.NODE_ENV}`,
  uid = null,
  email = null,
  message,
  metadata = {},
}) => {
  if (process.env.NODE_ENV === "development") {
    return;
  }
  try {
    await addDoc(collection(firebaseInit.firestore, "activity_logs"), {
      category,
      event,
      level,
      uid: Cookies.get("userId") || null,
      email,
      message,
      metadata,
      userAgent: navigator.userAgent,
      createdAt: serverTimestamp(),
    });
  } catch (err) {
    console.error("Logging failed:", err);
  }
};
